function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from "react";
import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import Icon from "../Icon/Icon";
import { isKeyPressed } from "../../../utils/isKeyPressed";
import { RETURN_KEY_CODE, SPACEBAR_KEY_CODE } from "../../../utils/Browser/keyCodes";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SECONDARY_TAG = "span";
function Expandable(_ref) {
  let {
    children = null,
    className = "",
    header,
    headerTag = "h5",
    id = "",
    secondary = false,
    initiallyCollapsed = false,
    expanded: controlledExpanded = null,
    onExpandChange = null
  } = _ref;
  const [expanded, setExpanded] = useState(controlledExpanded || !initiallyCollapsed);
  const HeaderTag = secondary ? SECONDARY_TAG : headerTag;
  const onKeyDown = e => {
    // Capture Enter and Space keys
    if (isKeyPressed(e, "Enter", RETURN_KEY_CODE) || isKeyPressed(e, " ", SPACEBAR_KEY_CODE)) {
      e.preventDefault();
      toggleExpansion(e);
    }
  };
  const toggleExpansion = e => {
    e.stopPropagation();
    setExpanded(!expanded);
    if (onExpandChange) {
      onExpandChange();
    }
  };
  const headerClass = secondary => cn({
    "py-3 px-4 hover:bg-medium-fill-grey": true,
    "bg-light-border-grey": !secondary,
    "border-b-2 border-light-border-grey text-xs": secondary,
    "text-xs uppercase font-heavy-font": headerTag === "h5" && !secondary
  });
  const bodyClass = (expanded, secondary) => cn("py-3 px-4 text-sm", {
    hidden: !expanded,
    block: expanded,
    "border-b-2 border-light-border-grey": secondary
  });
  const chevronClass = expanded => cn({
    "float-right flex-none": true,
    "transform rotate-0": expanded,
    "transform rotate-180": !expanded
  });
  return /*#__PURE__*/_jsx("section", _objectSpread(_objectSpread({
    className: className
  }, id ? {
    id
  } : {}), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("button", {
        className: "w-full text-left text-text-blue",
        onClick: toggleExpansion,
        onKeyDown: onKeyDown,
        id: "".concat(id, "-button"),
        tabIndex: 0,
        "aria-expanded": expanded,
        children: /*#__PURE__*/_jsx("div", {
          className: headerClass(secondary),
          children: /*#__PURE__*/_jsxs(HeaderTag, {
            className: "flex flex-no-wrap justify-between items-center",
            children: [/*#__PURE__*/_jsx("div", {
              className: "flex-auto font-heavy-font",
              children: header
            }), /*#__PURE__*/_jsx(Icon, {
              icon: "ChevronArrow",
              color: "medium-grey",
              size: 12,
              className: chevronClass(expanded)
            })]
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: bodyClass(expanded, secondary),
        children: children
      })]
    })
  }));
}
Expandable.propTypes = {
  /** children for content inside */
  children: PropTypes.node,
  /** optional className for reference */
  className: PropTypes.string,
  /** Whether this card is expanded. */
  expanded: PropTypes.bool,
  /** string or node header used as the toggle for the main component */
  header: PropTypes.node,
  /** tag string used for semantic headings, it will not affect the styles */
  headerTag: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  /** optional id for reference */
  id: PropTypes.string,
  /** boolean to determine if container is rendered expanded */
  initiallyCollapsed: PropTypes.bool,
  /** function that is called when toggleExpansion is called */
  onExpandChange: PropTypes.func,
  /** determines style and color of expandable container */
  secondary: PropTypes.bool
};
export default Expandable;
//# sourceMappingURL=Expandable.js.map